/* ============
 * Account Module
 * ============
 */
import ActionsCurrency from '../currency/actions';
import GettersCurrency from '../currency/getters';
import MutationCurrency from '../currency/mutations';
import StateCurrency from '../currency/state';

import ActionsDetail from '../detail/actions';
import GettersDetail from '../detail/getters';
import MutationDetail from '../detail/mutations';
import StateDetail from '../detail/state';

export default {
  namespaced: true,
  actions: {
    ...ActionsCurrency,
    ...ActionsDetail
  },
  getters: {
    ...GettersCurrency,
    ...GettersDetail
  },
  mutations: {
    ...MutationCurrency,
    ...MutationDetail
  },
  state: {
    ...StateCurrency,
    ...StateDetail
  },
};
